import { createSlice } from "@reduxjs/toolkit";
import { ApplicationPreviewState } from "../types";
import { fetchApplicationPreview } from "./thunk/PreviewThunk";

const initialState: ApplicationPreviewState = {
  applicationPreview: null,
  loading: false,
  error: null,
};

const PreviewSlice = createSlice({
  name: "preview",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchApplicationPreview.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchApplicationPreview.fulfilled, (state, action) => {
        state.loading = false;
        state.applicationPreview = action.payload;
      })
      .addCase(fetchApplicationPreview.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Something went wrong";
      });
  },
});

export default PreviewSlice.reducer;
